import { render, staticRenderFns } from "./ThreadDetail.vue?vue&type=template&id=6583da4f&scoped=true&"
import script from "./ThreadDetail.vue?vue&type=script&lang=js&"
export * from "./ThreadDetail.vue?vue&type=script&lang=js&"
import style0 from "./ThreadDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ThreadDetail.vue?vue&type=style&index=1&id=6583da4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6583da4f",
  null
  
)

/* custom blocks */
import block0 from "./ThreadDetail.vue?vue&type=custom&index=0&blockType=i18nf"
if (typeof block0 === 'function') block0(component)

export default component.exports